import { Component, OnInit } from '@angular/core';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';

@Component({
  selector: 'app-qr-download',
  templateUrl: './qr-download.component.html',
  styleUrls: ['./qr-download.component.scss']
})
export class QrDownloadComponent implements OnInit {
  link : any ;
  excelLink:any;
  qrList : any =[];
  cartontype:any=1;
  date = "" ;
  constructor(
    private apiService : ApiService,
    private apiConfig : ApiConfiguration
  ) { }

  ngOnInit() {
    this.getQRcodeList()
  }


  getQRcodeList(){
    this.apiService.get(this.apiConfig.cartonQrlist + `?date=${this.date}&type=${this.cartontype}`).subscribe((res : any)=>{
        this.qrList = res.data.qr_code_date_list;
    })
  }

  downloadZip(date){
    console.log(date)
    this.apiService.get(this.apiConfig.cartonQrDownload + `?date=${date}&feature_type=${this.cartontype}`).subscribe((res : any)=>{
      console.log(res)
      this.link = res.data.download_link;
      this.excelLink = res.data.excel_url
      debugger
      if(this.cartontype == 2){
        setTimeout(()=>{
          document.getElementById("zipLink").click();
          // setTimeout(() => {
          //    document.getElementById("excelLink").click();
          // }, 500);
        },500)
      }else{
        setTimeout(()=>{
          document.getElementById("zipLink").click();
        },500)
      }
  })

  }
  filter(){
    this.getQRcodeList();
  }
  reset(){
    this.date = "";
    this.cartontype = 1;
    this.getQRcodeList();
  }
}
